<template>
    <div style="display: flex; flex-direction: column; padding: 20px 0 10px 0; width: 100%; ">

        <div style="display: flex; margin: 10px 0; align-items: center; justify-content: space-between" >
            <div v-if="FreedomAppConfig.typeHeadline"
                 :style="{
                 color: FreedomAppConfig.primaryColor,
                 'font-weight': 600,
             }"
            ><span v-text="FreedomAppConfig.typeHeadline"></span>
              <span class="selected-tags" v-if="selected.length">
              <strong   v-for="(item, index) in selected" :key="item"
                                     class="selected-tag"
            > &nbsp;<span v-text="item"/><span v-if="index<selected.length-1">,</span>
              </strong>
              </span>
            </div>

        </div>
        <div style="display: flex; flex-flow: row wrap;  margin: 10px 0; align-items: center; justify-content: space-between;">
            <div style="display: flex;" class="searchDropdowns-cell">
                <div class="searchType" v-for="type in types" :key="type['value']">
                    <button  type="button" class="button dropdown"
                         :data-toggle="type.prefix+'-dropdown'"
                            :class="[ activeType === type.prefix || (selectedTagsByTypes[type.prefix] && selectedTagsByTypes[type.prefix].length > 0) ? FreedomAppConfig.filterButtonClassActive : FreedomAppConfig.filterButtonClass]"
                            @click="toggleSelectedType(type, $event)"
                            v-text="`By ${type['value']} (${getLength(selectedTagsByTypes[type.prefix])}) `"
                    />
                  <div class="dropdown-pane is-open"  v-if="activeType === type.prefix"  :id="type.prefix+'-dropdown'" data-dropdown data-auto-focus="true">
                    <check-group v-model="selectedTagsByTypes[type.prefix]" :items="activitiesByType(type)" @update="applyFilters"></check-group>
                  </div>
                </div>
              <div class="searchType">
              <button  type="button" class="button dropdown"
                       :class="[ activeType === 'date' || selectedDate !== '' ? FreedomAppConfig.filterButtonClassActive : FreedomAppConfig.filterButtonClass]"
                       @click="toggleSelectedType({prefix: 'date'}, $event)"
                       v-text="`By Date `"
              />
              <div class="dropdown-pane is-open"  v-if="activeType === 'date'"  id="date-dropdown" data-dropdown data-auto-focus="true">
                <div>
                  <button class=" button clear" @click="onDatepickerSelect('today')">From Today</button>
                  <p>Or</p>
                  <date-picker ref-name="from"  format=" MMM dd yyyy" v-model="selectedDate"  @selected="onDatepickerSelect"   input-class="datepicker-input" placeholder="Start After" :clear-button="true"></date-picker>
                  <p>Currently showing events from<br> {{dateFormated}}</p>

                  <div class="button-wrapper" style="display: flex; justify-content: space-between">
                    <button type="button" class="button primary"  @click="applyFilters(true)">Apply</button>
                    <button type="button" class="button clear"  @click="applyFilters(false)">Close</button>
                  </div>

                </div>
              </div>
              </div>
            </div>
            <div class="searchClear-cell">

                <button type="button" class="button primary searchClear"  @click="applyFilters('clear')"
                      v-text="`Clear All Filters (${countSelected})`"
                      :class="['type-select']"

                />
            </div>
        </div>
    </div>
</template>

<script>
  import Lodash from "lodash";
  import FreedomAppConfig from "../FreedomAppConfig"
  import CheckGroup from './check-group';
  import DatePicker from "@sum.cumo/vue-datepicker";
  import '@sum.cumo/vue-datepicker/dist/vuejs-datepicker.css'

  export default {
    name: "type-group-select",
    components: {CheckGroup, DatePicker},
    props: {
      types: {type: Array, required: true},
      selected: {type: Array, required: false},
      activities: {type: Array, required: false},
      value: {type: Object, default: () => {}},
      dateFormated: {type: String},
      // items: {type: Array, required: true},
    },
    data: function() {
      return {
        FreedomAppConfig,
        searchValue: '',
        selectedCounts: {},
        selectedTagsByTypes: {},
        activeType: '',
        selectedDate: ''
      };
    },
    computed: {
      countSelected: function() {
        return this.selected.length;
      },

      // computedItems: function() {
      //   let items = this.items.map(i => i['value']);
      //   // this.selected.filter(x => !items.includes(x)).forEach(x => items.unshift(x));
      //   return items;
      // },

    },
    methods: {
      getLength: function(value){
         if(value != undefined){
           return value.length;
         }
         return 0;
      },
      onDatepickerSelect: function(date){
        if(date === 'today'){
          date = new Date();
        }
        this.selectedDate = date;
        this.$emit('date', date);
      },

      activitiesByType(type){
        return this.activities.filter(a => a['prefix'] === type['prefix']);
      },
      toggleSelectedType: function(newType){
        this.activeType = newType.prefix;
      },
     applyFilters: function(cmd){
       this.activeType = '';
       if(cmd === 'clear'){
         this.types.forEach(type => this.selectedTagsByTypes[type.prefix] = []);
       }
       this.$emit('input', this.selectedTagsByTypes);

     },
      updateSelectedTags: function(newItem){
        this.$emit('tag', newItem);
        this.toggleSelectedType({})

      }
    },
    watch: {
      searchValue: Lodash.debounce(function(newValue) {
        this.$emit('search', newValue);
      }, 300),
    },
    beforeMount: async function() {

      this.selectedTagsByTypes = Object.assign({}, this.selectedTagsByTypes, this.value)

    },

  };

</script>

<style scoped>
    .searchType {
      margin-right: 1rem;
    }

    .searchType .button, .searchType .dropdown-pane {
      text-transform: capitalize;
    }

    .selected-tags {
        text-transform: capitalize;
    }
</style>